import React from "react";
import axios from "axios";
import { ERROR_MSG, PATHS } from "./constant";
import { isAuthenticated, setLocalstorage } from "./helper";
import { get } from "lodash";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "./customToast";
import sub from "date-fns/sub/index";
export default {
  setupInterceptors: (store, history) => {
    // axios.interceptors.request.use(function(config) {
    //   const token = localStorage.getItem('token');
    //   if (token) {
    //     config.headers.token = `Bearer ${token}`;
    //   }
    //   return config;
    // }, function(err) {
    //   return Promise.reject(err);
    // });

    axios.interceptors.response.use(
      response => {
        // const responseObj = response.data;
        if (get(response, "headers.token")) {
          //setLocalstorage("token", get(response, "headers.token"));
        }
        return response;
      },
      error => {
        if (get(error, "response.status") === 401) {
          localStorage.clear();
          sessionStorage.clear();
          history.push(PATHS.HOME);
        }
        if (get(error, "response.status") === 403) {
          toast.error(
            <p className="toast-text-alignment">
              {error.response.message || ERROR_MSG.ERROR_MESSAGE_403}
            </p>,
            errorToastStyle
          );
        }
        if (get(error, "response.status") === 500) {
          if (
            error &&
            error.message !== "Request aborted" &&
            error.message !== "Operation canceled"
          ) {
            history.push(PATHS.SERVER_ERROR);
          }
        }
        if (get(error, "response.status") >= 502) {
          if (
            error &&
            error.message !== "Request aborted" &&
            error.message !== "Operation canceled"
          ) {
            history.push(PATHS.SOMETHING_WENT_WRONG);
          }
        }
        return Promise.reject(error);
      }
    );
  }
};
